import Axios from '@/components/api/axios.js'

/**********************************************************************************
 * 导出excel功能
 **********************************************************************************/
export default {
	/**
	 * 导出日报
	 */
	exportDayHistory: (fileName, deviceJson, time, interval, success, failure) => {
		Axios.post('/report/exportDayHistory.do', {
			fileName,
			deviceJson,
			time,
			interval
		}, success, failure)
	},
	/**
	 * 导出周报
	 */
	exportWeekHistory: (fileName, deviceJson, time, success, failure) => {
		Axios.post('/report/exportWeekHistory.do', {
			fileName,
			deviceJson,
			time
		}, success, failure)
	},
	/**
	 * 导出月报
	 */
	exportMonthHistory: (fileName, deviceJson, time, success, failure) => {
		Axios.post('/report/exportMonthHistory.do', {
			fileName,
			deviceJson,
			time
		}, success, failure)
	},
	/**
	 * 导出季报
	 */
	exportQuarterHistory: (fileName, deviceJson, time, success, failure) => {
		Axios.post('/report/exportQuarterHistory.do', {
			fileName,
			deviceJson,
			time
		}, success, failure)
	},
	/**
	 * 导出年报
	 */
	exportYearHistory: (fileName, deviceJson, time, success, failure) => {
		Axios.post('/report/exportYearHistory.do', {
			fileName,
			deviceJson,
			time
		}, success, failure)
	},
	/**
	 * 导出多个设备月报（原有接口）
	 */
	exportDeviceMonthHistory: (fileName, deviceNos, type, apptypes, time, interval, success, failure) => {
		Axios.post('/report/exportDeviceMonthHistory.do', {
			fileName,
			deviceNos,
			type,
			apptypes,
			time,
			interval
		}, success, failure)
	},
	/**
	 * 导出单个设备日报（原有接口）
	 */
	exportDeviceDayValue: (fileName, deviceNo, time, success, failure) => {
		Axios.post('/report/exportDeviceDayValue.do', {
			fileName,
			deviceNo,
			time
		}, success, failure)
	},
	/**
	 * 导出设备指定时间段的excel表格
	 */
	exportHistoryBetweenDate: (fileName, deviceJson, bgTime, endTime, interval, success, failure) => {
		Axios.post('/report/exportHistoryBetweenDate.do', {
			fileName,
			deviceJson,
			bgTime,
			endTime,
			interval
		}, success, failure)
	},

	/**
	 * 导出设备的电能消耗（日周月季年）
	 * fileName（文件名）
	 * variableNames(变量)
	 * time（时间）
	 * dateType（时间类型）
	 */
	exportHistoryDifferenceRanking: (fileName, variableNames, time,dateType, success, failure) => {
		Axios.post('/report/exportHistoryDifferenceRanking.do', {
			fileName,
			variableNames,
			time,
			dateType
		}, success, failure)
	},
	/**
	 * 导出历史值
	 */
	exportHistoryDifferenceRankingCustom: (fileName, variableNames, time, endTime, dateType, success, failure) => {
		Axios.post('/report/exportHistoryDifferenceRanking.do', {
			fileName,
			variableNames,
			time,
			endTime,
			dateType
		}, success, failure)
	},
	/**
	 * 导出指定单位指定月份的运维报告
	 */
	exportUnitMonthReport: (unitId, time, success, failure) => {
		Axios.post('/report/exportUnitMonthReport.do', {
			unitId,
			time,
		}, success, failure)
	},
	/**
	 * 导出指定单位指定月份的pdf格式运维报告
	 */
	exportUnitMonthReportPdf: (unitId, time, success, failure) => {
		Axios.post('/report/exportUnitMonthReportPdf.do', {
			unitId,
			time,
		}, success, failure)
	},
	/**
	 * 导出全站能耗设备报表
	 */
	exportAllPowerDifferenceRanking: ( time, success, failure) => {
		Axios.post('/report/exportAllPowerDifferenceRanking.do', {
			time,
		}, success, failure)
	},
	exportAllPowerDifferenceRankingCustom: ( time, endTime, dateType, success, failure) => {
		Axios.post('/report/exportAllPowerDifferenceRanking.do', {
			time,
			endTime,
			dateType,
		}, success, failure)
	},
	/**
	 * 导出全站能耗设备报表-新的
	 */
	exportUnitMonthReportWord: (unitId, time, success, failure) => {
		Axios.post('/report/exportUnitMonthReportWord.do', {
			unitId,
			time,
		}, success, failure)
	},
	/**
	 * 自定义报表
	 */
	getCustomReportTree: ( success, failure) => {
		Axios.post('/report/getCustomReportTree.do', {
		}, success, failure)
	},
	/**
	 * 日周月季年自定义报表导出
	 * @param{Stirng} deviceJson
	 * @param{Stirng} time
	 * @param{Stirng} endTime
	 * @param{Stirng} interval
	 * @param{Stirng} fileName
	 * @param{Stirng} dateType
	 */
	exportVariableHistoryWithDateType: (deviceJson, time, endTime, interval, fileName, dateType, success, failure) => {
		Axios.post('/report/exportVariableHistoryWithDateType.do', {
			deviceJson,
			time,
			endTime,
			interval,
			fileName,
			dateType,
		}, success, failure)
	},
	/**
	 * 历史示值导出
	 */
	exportHistoryIndicationValue: (deviceNos,beginTime,endTime, success, failure) => {
		Axios.post('/report/exportHistoryIndicationValue.do', {
			deviceNos,beginTime,endTime }, success, failure)
	},
	/**
	 * 日周月季年pdf导出
	 * @param{Stirng} deviceJson
	 * @param{Stirng} time
	 * @param{Stirng} endTime
	 * @param{Stirng} interval
	 * @param{Stirng} fileName
	 * @param{Stirng} dateType
	 * @param{Stirng} type 图表类型
	 */
	exportVariableHistoryWithDateTypeForPdf: (deviceJson, time, endTime, interval, fileName, dateType, type, success, failure) => {
		Axios.post('/report/exportVariableHistoryWithDateTypeForPdf.do', {
			deviceJson,
			time,
			endTime,
			interval,
			fileName,
			dateType,
			type,
		}, success, failure)
	},

}
